import { formatCurrency } from "../../../../helpers";
import { RoutedModal, WarningDialog } from "../../../common";
import { useDeleteGoalsMutation } from "../../../../hooks/api/mutations/usePerformance";
import { useContext } from "react";
import { ToastContext } from "../../../../hooks/context";

export const DeleteGoalsPrompt = ({
  isDeleteGoal,
  setIsDeleteGoal = () => {},
  closeModal = () => {},
}) => {
  const triggerToast = useContext(ToastContext);
  const { mutate: deleteGoals, isLoading: isDeletingGoals } =
    useDeleteGoalsMutation();

  const handleDeleteGoals = () => {
    deleteGoals(
      { id: isDeleteGoal?.id },
      {
        onSuccess: () => {
          triggerToast("Goal deleted successfully", "success");
          closeModal();
        },
      },
    );
  };

  return (
    <RoutedModal
      headerTitle={`Delete Goal: ${isDeleteGoal?.name}`}
      isActive={!!isDeleteGoal}
      width={500}
      closeModal={() => closeModal()}
      style={{ height: "auto" }}
    >
      <WarningDialog
        cancelModal={() => setIsDeleteGoal(null)}
        closeModal={() => closeModal()}
        handler={() => handleDeleteGoals()}
        isLoading={isDeletingGoals}
      >
        <p>
          Goal Name: <span className="dark--text">{isDeleteGoal?.name}</span>
        </p>
        <p>
          Target Amount:{" "}
          <span className="dark--text">
            {formatCurrency({
              value: isDeleteGoal?.target_amount,
              currencyCode: isDeleteGoal?.store?.currency_code,
            })}
          </span>
        </p>
      </WarningDialog>
    </RoutedModal>
  );
};
